export default "__VITE_ASSET__0j19y_BS__"